import { onlyDigits } from '@/shared/lib/format';

const REPEATED_SEQUENCES = new Set([
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
]);

function checkDigit(base: string): number {
  let sum = 0;
  let pos = base.length - 7;
  for (let i = base.length; i >= 1; i--) {
    sum += Number(base.charAt(base.length - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  const result = sum % 11;
  return result < 2 ? 0 : 11 - result;
}

/** Valida dígitos verificadores de CNPJ — replica legacy/fixe-link-2 `public/js/valida_cnpj.js`. */
export function isValidCnpj(value: string): boolean {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14 || REPEATED_SEQUENCES.has(cnpj)) return false;

  const base12 = cnpj.substring(0, 12);
  const digits = cnpj.substring(12);
  if (checkDigit(base12) !== Number(digits.charAt(0))) return false;

  const base13 = cnpj.substring(0, 13);
  if (checkDigit(base13) !== Number(digits.charAt(1))) return false;

  return true;
}
